import Context from './context';
import jass2lua from './jass2lua';
import * as types from './types';
import compileNatives from './compilenatives';

export default {
  Context,
  jass2lua,
  types,
  compileNatives,
};
